import React, { FunctionComponent } from 'react';
import { Header } from '../../navigation/Header';
import menuData from '../../../dist/menuData.json';
import styled from 'styled-components';

interface Props {
  hideNavigation?: boolean;
  isFunnel?: boolean;
}

export const OldVersionHeaderSharedComponent: FunctionComponent<Props> = ({ isFunnel }) => {
  return (
    <GlobalHeaderStyles>
      <Header rootMenuItems={menuData} hideNavigation={true} isFunnel={isFunnel} isMinimalistHeader={true} isOldVersion={true} />
    </GlobalHeaderStyles>
  );
};

/* We reinject here needed global css as made on Phoenix */
const GlobalHeaderStyles = styled.div`
  * {
    box-sizing: border-box;
  }

  a {
    cursor: pointer;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent !important;
    outline: none !important;
  }

  input,
  textarea,
  select {
    font-family: 'StyreneA', sans-serif;
  }

  strong {
    font-weight: 700;
  }
  --font-styrene: StyreneA, sans-serif;
  --header-text: #323232;
  --header-background: #f5f5f5;
  --breadcrumb-color: #323232;
  --hirondelle: #323232;
  --price-tag-color: #33d1ff;
  --main-text: #323232;
  --main-text-light: #646464;
  --light-color: #e5e5e5;
  --accent-color: #33d1ff;
  --accent-color-light: #e4f9ff;
  --accent-color-ultra-light: #ee7b9c0a;
  --accent-color-2: #323232;
  --table-text-color: #323232;
  --light-backgrounds: #f5f5f5;
  --hint-color: #646464;
  --mid-light-grey: #afafaf;
  --form-valid: #00b67a;
  --exa-pink: #ff3d77;
  --exa-pink-darker: #bf2e5a;
  --alert-color: #e1412b;
  --header-height: 94px;
  --height-mobile-header: 96px;

  @-webkit-keyframes spinAround {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }
  @keyframes spinAround {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }
`;
